<div *ngIf="loading" class="absolute inset-0 flex justify-center items-center">
	<mat-spinner></mat-spinner>
</div>

<div [class.opacity-0]="loading">
	<div class="container">
		<h1 class="center">
			Modification de l'inventaire de la lingerie '{{ inventaireDetails?.lingerie.libelle}}'
		</h1>
		<h2 class="subtitle">
			Livraison du {{ dateLivraison | date: 'EEEE': 'fr' }}
			{{ dateLivraison | date: 'dd/MM/yyyy': 'fr'}}
		</h2>


		<div class="flex justify-center">
			<div class="clamp-commande">
				<table class="styled-table">
					<thead>
						<tr>
							<th>Article</th>
							<th>Dotation</th>
							<th>Restant</th>
							<th *ngIf="!isBesoin">Pre-commande</th>
							<th *ngIf="isBesoin">Besoin</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let ligne of inventaireDetails?.inventaire_lignes">
							<td>{{ ligne.article.designation }}</td>
							<td>{{ ligne.dotation }}</td>
							<td>
								<mat-form-field>
									<mat-label></mat-label>
									<input type="number" matInput #restant [value]="ligne.restant" min=0
										(keypress)="omit_not_number($event)" max="ligne.dotation"
										(change)="updateInventaire(ligne, $event)" #txtInput
										(keydown.enter)="txtInput.blur()">
								</mat-form-field>
							</td>
							<td>{{ ligne.restant != null ? ligne.qte_commande : 'Non inventorié' }}</td>
						</tr>
					</tbody>
				</table>

			</div>
		</div>
		<div class="buttons-center">
			<button mat-raised-button (click)="refuse()" color="white">Retour</button>
			<button mat-raised-button type="button" (click)="saveInventaire(inventaireDetails)">
				Enregistrer
			</button>
		</div>
	</div>
</div>
<router-outlet></router-outlet>